import React, { FC } from 'react'

import Failure from './Failure'
import PlaidOption from './PlaidOption'
import PlaidConnect from './PlaidConnect'
import { usePlaid } from './PlaidContext'
import { redirectTo } from '@mortgage-pos/utils'
import { useStoreState } from '@mortgage-pos/ui/store'
import ManualUploadOption from './ManualUploadOption'
import { borrowerPortalLoginUrl } from '@mortgage-pos/data'

interface PlaidAssetsProps {
  modifierClass?: string
}

export const PlaidAssets: FC<PlaidAssetsProps> = ({ modifierClass }) => {
  const { usePlaidUpload } = usePlaid()
  const { error } = useStoreState((state) => state.plaid)
  const { isAuthenticated } = useStoreState((state) => state.authentication)

  if (!isAuthenticated) {
    redirectTo(borrowerPortalLoginUrl)
  }

  if (error) {
    return <Failure />
  }

  if (usePlaidUpload) {
    return <PlaidConnect />
  }

  return (
    <div className="plaid-assets" data-testid="plaid-assets">
      <PlaidOption />
      <div className="plaid-assets__divider" />
      <ManualUploadOption />
    </div>
  )
}

export default PlaidAssets
